import clsx from "clsx";
import type { ButtonHTMLAttributes, ReactNode } from "react";

export type NavItemButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: ReactNode;
  label: string;
  active?: boolean;
  /** Icon-only rendering for a collapsed sidebar; the label becomes the tooltip. */
  collapsed?: boolean;
  activeClassName?: string;
  inactiveClassName?: string;
};

/** Sidebar navigation entry. Styling for the active and inactive states comes from the caller's theme. */
export function NavItemButton({
  icon,
  label,
  active = false,
  collapsed = false,
  activeClassName,
  inactiveClassName,
  className,
  type = "button",
  ...props
}: NavItemButtonProps) {
  return (
    <button
      type={type}
      aria-current={active ? "page" : undefined}
      title={collapsed ? label : undefined}
      className={clsx(
        "flex w-full items-center gap-3 py-4 transition-all",
        collapsed ? "justify-center px-2" : "px-6",
        active ? activeClassName : inactiveClassName,
        className
      )}
      {...props}
    >
      {icon}
      {!collapsed ? <span className="text-sm font-medium">{label}</span> : null}
    </button>
  );
}
